import React, { useState } from "react";
import styled from "styled-components";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";
import { humanize } from "../components/common";
const Summary = styled.div`
	box-shadow: 1px 1px 0px #efefef;
	background: white;
	padding: 10px;
	margin: 10px 0px;
	border-radius: 2px;
	border: 1px solid #eee;
	font-size: 12px;
	cursor: pointer;
	table {
		font-size: 12px;
		margin-top: 20px;
	}
	.head {
		font-weight: bold;
	}
`;

const Val = styled.div`
	font-size: 14px;
	font-weight: 400;
`;

const description = [
	{
		description: "The author of the PDF document is a non trusted author",
		fraud_type: "author_fraud",
	},
	{
		description: "PDF modification date not equal to the PDF creation date",
		fraud_type: "date_fraud",
	},
	{
		description:
			"Balance after the transaction is not consistent with the previous balance or overall balance.",
		fraud_type: "inconsistent_transaction",
	},
	{
		description: "More cash deposits than the salary amount in a month",
		fraud_type: "more_cash_deposits_than_salary",
	},
	{
		description: "Salary credits are the same for four consecutive months",
		fraud_type: "salary_remains_unchanged_4_months",
	},
	{
		description:
			"Salary credited at the end of Financial year (FEB-MAR or MAR-APRIL) is unchanged",
		fraud_type: "salary_remains_unchanged",
	},
	{ description: "Salary credited on bank holidays", fraud_type: "salary_credited_bank_holiday" },
	{ description: "Salary credit is a multiple of 1000", fraud_type: "salary_1000_multiple" },
	{
		description: "Number of cash transactions is more than 50%",
		fraud_type: "mostly_cash_transactions",
	},
	{ description: "Total credits and total debits are equal", fraud_type: "equal_credit_debit" },
	{
		description: "Business account with no credit transaction in 15 days",
		fraud_type: "more_than_15_days_credit",
	},
	{
		description: "EOD balance is negative for a non business account",
		fraud_type: "negative_balance",
	},
	{ description: "Tax paid in multiple of 100", fraud_type: "tax_100_multiple" },
	{ description: "RTGS amount is less than allowed limit", fraud_type: "min_rtgs_amount" },
	{ description: "RTGS on bank holidays", fraud_type: "rtgs_bank_holiday_transaction" },
	{
		description: "Cash Deposit on bank holidays",
		fraud_type: "cash_deposit_bank_holiday_transaction",
	},
	{ description: "Cheque Transfer on bank holidays", fraud_type: "chq_bank_holiday_transaction" },
	{
		description: "Outward Cheque Bounce on bank holidays",
		fraud_type: "outward_cheque_bounce_bank_holiday_transaction",
	},
	{
		description: "Inward Cheque Bounce on bank holidays",
		fraud_type: "inward_cheque_bounce_bank_holiday_transaction",
	},
];
const toINR = (num) => {
	return "₹ " + parseInt(num).toLocaleString("en-IN");
};
const SummaryWrapper = (props) => {
	const [expand, setExpand] = useState(false);
	const data = props.data;
	const type = props.type;
	const transactions = props.transactions;
	return (
		<Summary
			style={{
				cursor: data.some((ele) => {
					return ele.transaction_hash;
				})
					? "pointer"
					: "default",
			}}
		>
			<div
				className="columns"
				onClick={() =>
					data.some((ele) => {
						return ele.transaction_hash;
					})
						? setExpand(!expand)
						: ""
				}
			>
				<div className="column col-3">
					<Val>{humanize(type)}</Val>
				</div>
				<div className="column col-6">
					<Val>
						{description.map((element) => {
							if (element.fraud_type == type) return element.description;
						})}
					</Val>
				</div>
				<div className="column col-2">
					<Val
						style={{ color: data[0].fraud_category == "behavioural" ? "#FFA000" : "#EB5353" }}
					>
						{humanize(data[0].fraud_category)}
					</Val>
				</div>

				{data.some((ele) => {
					return ele.transaction_hash;
				}) ? (
					<div className="column col-1" style={{ display: "flex", alignItems: "center" }}>
						{expand ? <FiChevronUp /> : <FiChevronDown />}
					</div>
				) : (
					""
				)}
			</div>
			{expand && (
				<table className="table table-striped" style={{ borderTop: "1px solid #bbb" }}>
					<thead>
						<tr>
							<th>Date</th>
							<th>Amount</th>
							<th>Balance</th>
							<th>Channel</th>
							<th>Transaction Note</th>
						</tr>
					</thead>
					<tbody>
						{transactions.map((row) => {
							if (data.some((ele) => ele.transaction_hash == row.hash)) {
								return (
									<tr>
										<td>{row.date}</td>
										<td>{toINR(row.amount)}</td>
										<td>{toINR(row.balance)}</td>
										<td>{row.transaction_channel}</td>
										<td>{row.transaction_note}</td>
									</tr>
								);
							}
						})}
					</tbody>
				</table>
			)}
		</Summary>
	);
};
export default function FraudTable(props) {
	let frauds = props.data.reduce(function (allNames, obj) {
		let key = obj.fraud_type;
		if (!allNames[key]) {
			allNames[key] = [];
		}
		allNames[key].push(obj);

		return allNames;
	}, {});

	return (
		<div>
			<Summary>
				<div className="columns">
					<div className="column col-3 head">FRAUD TYPES</div>
					<div className="column col-6 head">DESCRIPTION</div>
					<div className="column col-2 head">FRAUD CATEGORY</div>
				</div>
			</Summary>
			<table className="table">
				<tbody>
					{Object.keys(frauds).map((types) => {
						if (
							props.transactions.some((row) =>
								frauds[types].some((ele) => ele.transaction_hash == row.hash)
							) ||
							frauds[types][0].transaction_hash == null
						) {
							return (
								<SummaryWrapper
									type={types}
									data={frauds[types]}
									transactions={props.transactions}
								/>
							);
						}
					})}
				</tbody>
			</table>
		</div>
	);
}
